import { JSErrors } from "@newrelic/browser-agent/features/jserrors";
import { Logging } from "@newrelic/browser-agent/features/logging";
import { Metrics } from "@newrelic/browser-agent/features/metrics";
import { PageViewEvent } from "@newrelic/browser-agent/features/page_view_event";
import { PageViewTiming } from "@newrelic/browser-agent/features/page_view_timing";
import { SoftNav } from "@newrelic/browser-agent/features/soft_navigations";
import { Spa } from "@newrelic/browser-agent/features/spa";
import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";
import { useState } from "react";

import type { AgentOptions } from "@newrelic/browser-agent/src/loaders/agent.js";

const options: AgentOptions = {
	init: {
		distributed_tracing: { enabled: true },
		privacy: { cookies_enabled: true },
		ajax: { deny_list: [import.meta.env.VITE_NEWRELIC_BEACON] },
	},
	loader_config: {
		accountID: import.meta.env.VITE_NEWRELIC_ACCOUNT_ID,
		trustKey: import.meta.env.VITE_NEWRELIC_ACCOUNT_ID,
		agentID: import.meta.env.VITE_NEWRELIC_AGENT_ID,
		licenseKey: import.meta.env.VITE_NEWRELIC_LICENSE_KEY,
		applicationID: import.meta.env.VITE_NEWRELIC_APPLICATION_ID,
	},
	info: {
		beacon: import.meta.env.VITE_NEWRELIC_BEACON,
		errorBeacon: import.meta.env.VITE_NEWRELIC_ERROR_BEACON,
		licenseKey: import.meta.env.VITE_NEWRELIC_LICENSE_KEY,
		applicationID: import.meta.env.VITE_NEWRELIC_APPLICATION_ID,
		sa: 1,
	},
} satisfies AgentOptions;

const newRelicInitialize: () => BrowserAgent = () => {
	return new BrowserAgent({
		...options,
		features: [Metrics, PageViewEvent, PageViewTiming, Spa, JSErrors, SoftNav, Logging],
	});
};

export const useNewRelicInitialize = () => {
	const [newRelic] = useState(newRelicInitialize());

	return {
		newRelic,
	};
};
